import React, { useEffect, useState } from "react";
import { Button } from "../ui/button";

const KEY = "argus.cookie-consent.v1";

export default function CookieBanner() {
  const [show, setShow] = useState(false);
  useEffect(() => {
    if (!localStorage.getItem(KEY)) setShow(true);
  }, []);
  if (!show) return null;
  const choose = (v) => {
    localStorage.setItem(KEY, JSON.stringify({ at: Date.now(), choice: v }));
    setShow(false);
  };
  return (
    <div className="fixed bottom-4 left-4 right-4 md:left-auto md:right-6 md:bottom-6 md:max-w-md z-50 bg-panel text-ink rounded-xl shadow-lg p-5 border border-line animate-fade-in-up" data-testid="cookie-banner">
      <h3 className="font-display text-lg mb-2">Cookies that respect you.</h3>
      <p className="text-sm text-ink/70 mb-4">
        We use strictly necessary cookies to keep you signed in. Analytics and marketing cookies are off by default — your call.
      </p>
      <div className="flex flex-wrap gap-2">
        <Button onClick={() => choose("all")} className="bg-gold hover:bg-gold2 text-paper h-10" data-testid="cookie-accept-all">
          Accept All
        </Button>
        <Button onClick={() => choose("necessary")} variant="outline" className="border-line text-ink bg-transparent hover:bg-ink/10 h-10" data-testid="cookie-necessary-only">
          Necessary Only
        </Button>
      </div>
    </div>
  );
}
